<template>
  <div style="background-color: white" ref="chartContainer">
    <fade-transition>
      <bar-chart
        :height="chartHeight"
        :width="chartHeight"
        v-if="show.chart"
        :chart-data="chart"
        :options="bar_options"
      ></bar-chart>
    </fade-transition>
  </div>
</template>

<script>
import axios from "axios";
import VueAxios from "vue-axios";
import FadeTransition from "@/components/FadeTransition.vue";
import BarChart from "../components/BarChart";

export default {
  name: "Statistics",
  data() {
    return {
      task: {
        id: null,
        status: "",
        result: "",
        finished: false,
      },
      show: {
        chart: false,
      },
      bar_options: {
        responsive: true,
        legend: { display: false },
      },
      chart: {},
      chartHeight: 0,
    };
  },
  components: { axios, VueAxios, FadeTransition, BarChart },
  // TODO todo
  methods: {
    startTask: async function () {
      try {
        let response = await axios.post(
          process.env.ROOT_API + "startTask",
          {
            task_type: "statistics",
            metadata_filter: [],
            query_parameters: [],
            response_parameters: [],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 5000,
          }
        );
        this.task.id = response.data.id;

        this.checkStatus(this.task.id);
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    checkStatus: async function (taskId) {
      try {
        let response = await axios.get(
          process.env.ROOT_API + "getStatus/" + taskId,
          { timeout: 5000 }
        );
        this.task.status = response.data.status;

        if (this.task.status === "DONE") {
          this.getResult(taskId);
        } else if (this.task.status === "QUEUE") {
          setTimeout(() => {
            this.checkStatus(taskId);
          }, 300);
        } else if (this.task.status === "ERROR") {
          console.log(response);
        }
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    getResult: async function (taskId) {
      try {
        let response = await axios.get(
          process.env.ROOT_API + "getResult/" + taskId,
          { timeout: 5000 }
        );
        this.task.finished = true;
        this.mapChartData(response.data.result.statistics);
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    mapChartData: function (data) {
      this.chart = {
        label: "Statystyki",
        labels: [],
        datasets: [
          {
            backgroundColor: [
              "#ec4040",
              "#ec407c",
              "#ec40c7",
              "#b040ec",
              "#8840ec",
              "#4b40ec",
              "#405dec",
              "#4085ec",
              "#40a7ec",
              "#40d2ec",
              "#40d2ec",
              "#40a7ec",
              "#4085ec",
              "#405dec",
              "#4b40ec",
              "#8840ec",
              "#b040ec",
              "#ec40c7",
              "#ec407c",
              "#ec4040",
            ],
            data: [],
          },
        ],
      };
      // let left = 100
      // let fields = data.length >= this.howmanywords ? this.howmanywords : data.length;

      this.chart.labels = Object.keys(data);
      this.chart.datasets[0].data = Object.values(data);

      this.redrawChart();
    },
    resizeChart: function () {
      if (window.innerWidth > 768 && this.$refs.chartContainer) {
        this.chartHeight = Math.ceil(
          this.$refs.chartContainer.clientHeight * 1
        );
      } else {
        this.chartHeight = Math.ceil(470);
      }
    },
    redrawChart: function () {
      this.show.chart = false;
      this.resizeChart();
      setTimeout(() => {
        this.show.chart = true;
      }, 0);
    },
    handleResize: function (event) {
      if (this.task.finished) {
        this.redrawChart();
      }
    },
  },
  mounted() {
    this.startTask();
  },
  created: function () {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.concordance-row :hover {
  cursor: pointer;
  color: #007bff;
}
</style>



// WEBPACK FOOTER //
// src/views/Statistics.vue